/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const Profile = {

	getBidderProfile (context, userId, onSuccess, onError, options) {
		Api.get(context,
			"/profile/bidder-profile"
			+ "?userId=" + userId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getGenerateVolunteerCode (context, onSuccess, onError, options) {
		Api.get(context,
			"/profile/generate-volunteer-code"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getInnerUserProfile (context, userId, onSuccess, onError, options) {
		Api.get(context,
			"/profile/inner-user-profile"
			+ "?userId=" + userId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getSubBidderProfile (context, userId, onSuccess, onError, options) {
		Api.get(context,
			"/profile/sub-bidder-profile"
			+ "?userId=" + userId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getVolunteerProfile (context, userId, onSuccess, onError, options) {
		Api.get(context,
			"/profile/volunteer-profile"
			+ "?userId=" + userId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putBidderProfile (context, profileSettings, onSuccess, onError, options) {
		Api.put(context,
			"/profile/bidder-profile"
			, profileSettings
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putInnerUserProfile (context, profileSettings, onSuccess, onError, options) {
		Api.put(context,
			"/profile/inner-user-profile"
			, profileSettings
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putSubBidderProfile (context, profileSettings, onSuccess, onError, options) {
		Api.put(context,
			"/profile/sub-bidder-profile"
			, profileSettings
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putVolunteerProfile (context, profileSettings, onSuccess, onError, options) {
		Api.put(context,
			"/profile/volunteer-profile"
			, profileSettings
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
